import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import { Toast } from "primereact/toast";
import ReturnComponent from "./pensionComponent/returnComponent";
import {
  formatNumber,
  formatRoundedCHF,
  getBreadcrumbLabelsByAssetType,
  getTabLabelsByAssetType,
  HorizontalTabButtons,
  truncateText,
} from "../../../../../utility/helper";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DocumentComponent from "./pensionComponent/documentComponent";
import {
  addMediaService,
  deleteMediaService,
  getPensionMediaService,
  getPensionService,
} from "../../../../../services/transaction";
import { getMediaService } from "../../../../../services/company";
import { handleErrorRedirect } from "../../../../../utility/errorRedirect";
import { ProgressSpinner } from "primereact/progressspinner";
import Breadcrumb from "../../../../../components/Breadcrumb";

const ViewTransaction = () => {
  const [loading, setLoading] = useState(false);
  const [pensionLoading, setPensionLoading] = useState(false);
  const [pensionData, setPensionData] = useState([]);
  const [selectedButton, setSelectedButton] = useState("Return");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const [mediaData, setMediaData] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const { currency } = useSelector((state) => state.user);

  const toast = useRef(null);
  const dispatch = useDispatch();
  const userAssets = useSelector((state) => state.userAssets.data);
  const selectedAsset = useSelector((state) => state.userAssets.selectedAsset);
  const location = useLocation();
  const id = location?.state?.id || null;
  const navigate = useNavigate();
  const tabOptions = getTabLabelsByAssetType("6");
  const breadcrumbItems = getBreadcrumbLabelsByAssetType("Pension");

  useEffect(() => {
    if (selectedAsset) {
      GetPensionData();
      GetMediaData();
    }
  }, [selectedAsset]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 6, selectedAssetId: id })).then(
      (resultAction) => {
        if (fetchUserAssets.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      }
    );
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const GetPensionData = async () => {
    setPensionLoading(true);
    try {
      const response = await getPensionService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setPensionData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setPensionLoading(false);
    }
  };

  const GetMediaData = async () => {
    setLoading(true);
    try {
      const response = await getPensionMediaService(
        "Pension",
        selectedAsset?.id,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setMediaData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleMediaDelete = async (media_id) => {
    try {
      const response = await deleteMediaService(accessToken, media_id);
      if (response) {
        GetMediaData();
        dispatch(fetchUserAssets({ assetTypeId: 6, selectedAssetId: id }));
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "File deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleCreateMedia = async (media) => {
    setMediaLoading(true);
    try {
      const response = await addMediaService(
        media,
        selectedAsset.id,
        "Pension",
        accessToken
      );
      if (response) {
        GetMediaData();
        dispatch(fetchUserAssets({ assetTypeId: 6, selectedAssetId: id }));
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "File upload successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    } finally {
      setMediaLoading(false);
    }
  };
  const confirmMediaDelete = (mediaId, fileType) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: `Are you sure you want to delete this ${
        fileType ? fileType : "Media"
      }?`,
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleMediaDelete(mediaId, fileType),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div>
        {/* <Breadcrumb items={breadcrumbItems} className="md:ml-5 mb-2" /> */}
        <div className=" font-bold flex items-center md:flex-row flex-col md:justify-between px-4">
          <HorizontalTabButtons
            buttons={tabOptions}
            selected={selectedButton}
            onSelect={setSelectedButton}
          />
        </div>
        <div className="border border-lightPrimary/40 dark:border-info/40 p-3 mx-4 my-3 dark:bg-card-custom-radials bg-[length:100%_200%] bg-white">
          <div className="text-gray-400">
            <CustomDropdown
              options={userAssets}
              name={selectedAsset ? selectedAsset?.name : "Select Asset"}
              assetId={selectedAsset ? selectedAsset?.id : "Select Asset"}
              onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
              returnFullObject={true}
              truncateText={truncateText}
              size={19}
              disabled={!selectedAsset || !selectedAsset.name}
              className="inline-flex whitespace-nowrap disabled:cursor-not-allowed disabled:dark:opacity-75 disabled:border-none justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md text-lightPrimary dark:text-white border border-transparent hover:border-dark"
            />
          </div>
          <div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* <div className="ml-1 text-2xl text-lightPrimary dark:text-primary-gradient">
                {selectedAsset?.name}
              </div> */}
              <div className="space-y-7 text-info dark:text-grey text-sm w-full max-w-[30rem]">
                <div className="flex items-baseline gap-4">
                  <span className="whitespace-nowrap ml-1">Value:</span>
                  <span className="text-2xl text-lightPrimary dark:text-primary-gradient font-medium break-anywhere">
                    {formatRoundedCHF(pensionData?.crr)} {currency ? currency : ""}
                  </span>
                </div>
              </div>

              <div className="grid grid-col-2  text-sm text-info dark:text-grey w-full max-w-[30rem]">
                <div className="space-y-1">
                  <div className="flex items-baseline gap-5">
                    <span className="whitespace-nowrap">1st Pillar:</span>
                    <span className="text-lightPrimary text-2xl dark:text-primary-gradient font-medium break-anywhere">
                      {formatRoundedCHF(pensionData?.p1 ? pensionData.p1 : 0)}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-4">
                    <span className="whitespace-nowrap">2nd Pillar:</span>
                    <span className="text-lightPrimary dark:text-primary-gradient font-medium text-2xl break-anywhere">
                      {formatRoundedCHF(pensionData?.p2 ? pensionData.p2 : 0)}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-4">
                    <span className="whitespace-nowrap">3rd Pillar:</span>
                    <span className="text-lightPrimary dark:text-primary-gradient font-medium text-2xl break-anywhere">
                      {formatRoundedCHF(pensionData?.p3 ? pensionData.p3 : 0)}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid grid-col-2 text-sm text-info dark:text-grey w-full max-w-[30rem]">
                <div className="space-y-1">
                  <div className="flex items-baseline gap-4">
                    <span className="whitespace-nowrap">2nd Pillar Fund:</span>
                    <span className="text-lightPrimary dark:text-primary-gradient break-anywhere font-medium text-2xl">
                      {formatRoundedCHF(pensionData?.pf2 ? pensionData.pf2 : 0)}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-5">
                    <span className="whitespace-nowrap">3rd Pillar Fund:</span>
                    <span className="text-lightPrimary dark:text-primary-gradient break-anywhere font-medium text-2xl">
                      {formatRoundedCHF(pensionData?.pf3 ? pensionData.pf3 : 0)}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 mx-4 dark:bg-card-custom-radials bg-white">
          {selectedButton === "Return" && (
            <ReturnComponent graphROI={pensionData} />
          )}
          {selectedButton === "Documents" && (
            <DocumentComponent
              handleMediaDelete={confirmMediaDelete}
              mediaData={mediaData}
              handleCreateMedia={handleCreateMedia}
            />
          )}
        </div>
      </div>
      {mediaLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50">
          <ProgressSpinner style={{ width: "60px", height: "60px" }} />
        </div>
      )}
    </>
  );
};

export default ViewTransaction;
